export default __webpack_public_path__ + "static/media/notes.879c00eb.jpg";